import {firebaseServices} from '../Firebase/FirebaseServices';


let DBScroeUpdate = (episode, currentScoreArr, dbTimeFolder) => {
    let ep1_score = 0;
    let ep2_score = 0;
    let ep3_score = 0;
    if(episode === 'episode1'){
        currentScoreArr.forEach((val) => {if(val===true){ep1_score=ep1_score+1}});
        firebaseServices.database().ref(`/userDetails/${dbTimeFolder}/episode1`).child('episode1_Score').set(ep1_score.toString())
    } else if(episode === 'episode2'){
        currentScoreArr.forEach((val) => {if(val===true){ep2_score=ep2_score+1}});
        firebaseServices.database().ref(`/userDetails/${dbTimeFolder}/episode2`).child('episode2_Score').set(ep2_score.toString())
    } else if(episode === 'episode3'){
        currentScoreArr.forEach((val) => {if(val===true){ep3_score=ep3_score+1}});
        firebaseServices.database().ref(`/userDetails/${dbTimeFolder}/episode3`).child('episode3_Score').set(ep3_score.toString())
    }
};

export default DBScroeUpdate;